/**
 * Costanti di gioco. Unità: pixel-mondo e secondi.
 * Toccare QUESTE per tarare il feel della "pompata" (gate Sprint 0).
 * La guida in-game (Sprint 1+) verrà autogenerata da questi valori, come TILT.
 */

// --- Simulazione: timestep FISSO con accumulatore (determinismo) ---
export const SIM_HZ = 120;
export const SIM_DT = 1 / SIM_HZ;
export const MAX_STEPS = SIM_HZ * 120; // hard-stop di sicurezza: 120s di run

// --- Tracciato ---
export const TRACK_DX = 24; // px-mondo tra i campioni fini dell'heightfield
export const TRACK_LENGTH = 9000; // px-mondo; ~30-50s a seconda della skill
export const FINISH_X = TRACK_LENGTH;
export const START_X = 140;

// --- Rider / fisica della pompata (Tiny Wings style) ---
// PREMI  = gravità forte -> ti "incolli" e acceleri in discesa (dive)
// RILASCI = gravità debole -> plani, le creste ti lanciano in volo
export const GRAV_RELEASE = 1500; // px/s^2 in planata
export const GRAV_PRESS = 3800; // px/s^2 in dive (la pompata)

// Spinta della POMPATA: quando premi e sei a terra, aggiunge accelerazione
// TANGENZIALE proporzionale alla pendenza e al suo segno:
//   discesa (ty>0) -> spinta in avanti (boost);  salita (ty<0) -> frenata.
// È ciò che rende la tecnica (premi-in-giù / lascia-in-su) davvero rilevante:
// senza, "tenere sempre premuto" costava troppo poco (gap strategie ~8%).
export const PUMP_ACCEL = 3200; // px/s^2 per unità di pendenza
export const START_VX = 340; // spinta iniziale al GO
export const MAX_SPEED = 1750; // cap di velocità
export const MIN_VX = 70; // anti-stallo: non ci si ferma mai del tutto in avanti
export const AIR_DRAG = 0.05; // attrito orizzontale in aria (per secondo)
export const GROUND_FRICTION = 0.015; // attrito lungo il pendio (per secondo)

// --- Wipeout: atterraggio storto = tempo perso, non game over ---
export const WIPE_ALIGN = 0.55; // allineamento velocità/pendio sotto cui si cade
export const WIPE_MIN_IMPACT = 560; // velocità normale d'impatto minima per il wipeout
export const WIPE_TIME = 0.85; // secondi di penalità (capriola)
export const WIPE_SPEED_KEEP = 0.32; // frazione di velocità mantenuta dopo il wipeout

// --- Seed dello Sprint 0 ---
// Un'unica collina condivisa così i PB/ghost sono confrontabili tra tutti.
// In Sprint 3 diventerà il seed del giorno (Europe/Rome), pattern Sequo.
export const SPRINT0_SEED = 'wake-sprint0-01';
